<template>
<div>
    <div class="pop_open ms-2" @click="showModal">
        <div class="info_icon">
            <SvgHeaderSvg :type="'info'" />
            </div>
    </div>
    <div v-if="flagShowModal">
        <Teleport  to="#teleports">
        <div class="modal fade" data-bs-backdrop="true"  id="metals" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="metals">
            <div class="modal-dialog">
                    <div class="modal-body modal-content model_block">                     
                        <div class="title_block mb-2">
                            <h3 class="mb-0 font-active">Add An Inscription</h3>
                            <span @click="hideModal"><SvgHeaderSvg type="close" class="largesvg"/></span>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-12">
                                <div class="m-info">
                                    <p>Make your ring truly yours with a free engraving at Friendly Diamonds. Whether it's a special date or a heartfelt message, adding a personal touch is easy.<br> <strong>Note:</strong> Some designs, like eternity rings, may not allow engraving.</p>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        </Teleport>
    </div>
</div>
</template>
    
<script setup>
const flagShowModal = ref(false)
const metals = ref(null)

const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
        const modalElement = metals.value;
        if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
        }
        });
    };

    const hideModal = () => {
        const modalElement = metals.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };
</script>
    
<style scoped>
.largesvg {
    transform: scale(1.3);
    }
.pop_open{
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

p {
    font-size: 16px;
    color: #6a6161;
    font-weight: normal;
    text-transform: none;
}

.title_block span {
    cursor: pointer;
}

h3{
    font-size: 20px;
}

@media(max-width: 767px){
    p{
        font-size: 14px;
    }
}

</style>